import {
  updateModalContext,
  useModalContext,
} from "../components/context/ModalContext";
import { cloneElement, useEffect, useState } from "react";
import { ModalForm } from "../components/modals/ModalForm";
import { DrawerView } from "../components/common/DrawerView";
import { DrawerProps } from "@mui/material";

export const openModalForm = ({
  source,
  ...rest
}: {
  source: string | any;
  [key: string]: any;
}) => {
  return updateModalContext({
    type: "modal_form",
    key: source,
    source,
    ...rest,
  });
};

export const openDrawer = ({
  component,
  anchor,
  ...rest
}: {
  component: string | any;
  anchor?: DrawerProps["anchor"];
  [key: string]: any;
}) => {
  return updateModalContext({
    type: "drawer",
    key: component,
    component,
    anchor,
    ...rest,
  });
};

export const openBottomSheet = ({
  component,
  footer,
  ...rest
}: {
  component: "details" | "filters" | "tabs" | "method_picker";
  footer?: any;
  [key: string]: any;
}) => {
  return updateModalContext({
    type: "drawer",
    key: `${component}_${rest?.source || ""}_${rest?.id || ""}`, // ← add id
    component,
    anchor: "bottom",
    componentProps: {
      footer,
      ...rest,
    },
  });
};

// Components handler
const modalComponentHandler: any = {
  modal_form: ModalForm,
  drawer: DrawerView,
};

export const ModalController = () => {
  const [show, setShow] = useState(false);
  const modalState = useModalContext();
  const { type } = modalState || {};

  // get modal component
  const ModalComponent = modalComponentHandler[type];

  function dismiss() {
    setShow(false);
  }

  useEffect(() => {
    if (type) {
      setShow(true);
    }
  }, [type, modalState]);

  const props = { show, dismiss, ...modalState };

  if (!ModalComponent) return null;

  const renderBody = () => cloneElement(<ModalComponent />, props);

  return renderBody();
};
